<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="$b()">
    <Swiper
      ref="featuresSwiper"
      class="sub-features-cont clearfix show-only-on-mobile"
      v-bind="{
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: false,
          clickable: true,
        },
      }"
      @slide-change="handleSlideChange"
    >
      <SwiperSlide>
        <div class="sub-features">
          <img
            v-if="baseSku === 'velans'"
            src="~/assets/images/pdp/velans-sub-features-1.jpg"
            :class="$b('slide-image')"
          />
          <img
            v-if="baseSku === 'vulcans'"
            src="~/assets/images/pdp/vulcans-sub-features-1.jpg"
            :class="$b('slide-image')"
          />
          <img
            v-if="baseSku === 'airas'"
            src="~/assets/images/pdp/airas-sub-features-1.jpg"
            :class="$b('slide-image')"
          />

          <div class="text-cont">
            <BaseHeading size="h2">
              {{ $tr('Find your Fit.') }}
            </BaseHeading>
            <p
              v-html="
                $tr(
                  '{productName} come with 4 different sized and easily interchanged nose pads for a fully adaptable fit that will suit any face, brow and nose shape.',
                  { productName }
                )
              "
            />
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div class="sub-features">
          <img
            v-if="baseSku === 'velans'"
            src="~/assets/images/pdp/velans-sub-features-2.jpg"
            :class="$b('slide-image')"
          />
          <img
            v-if="baseSku === 'vulcans'"
            src="~/assets/images/pdp/vulcans-sub-features-2.jpg"
            :class="$b('slide-image')"
          />
          <img
            v-if="baseSku === 'airas'"
            src="~/assets/images/pdp/airas-sub-features-2.jpg"
            :class="$b('slide-image')"
          />

          <div class="text-cont">
            <BaseHeading size="h2">
              {{ $tr('Lock it in.') }}
            </BaseHeading>
            <p
              v-html="
                $tr(
                  'Earsocks and nose pads made from our Grip-Lock™ hydrophilic rubber for three evenly balanced points of grip. The more you sweat the more your {productName} hold in place.',
                  { productName }
                )
              "
            />
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div class="sub-features">
          <img
            src="~/assets/images/pdp/sub-features-3.jpg"
            :class="$b('slide-image')"
          />
          <div class="text-cont iris">
            <VisionIcon icon="iris" />
            <BaseHeading size="h2">
              {{ $tr('Built to Adapt.') }}
            </BaseHeading>
            <p
              v-html="
                $tr(
                  'Our new 8KO® Iris™ photochromic lens adjusts to fast-changing light conditions, for no lapse in vision and ultimate focus.'
                )
              "
            />
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    <div :class="$b('pagination-cont')">
      <span
        v-for="(n, index) in 3"
        :key="index"
        :class="$b('pagination-bullet', { active: index === activeSlide })"
        tabindex="0"
        role="button"
        :aria-label="`Go to slide ${index}`"
        @click="setActiveSlideByIndex(index)"
      />
    </div>
    <div class="sub-features-cont clearfix show-only-on-desktop">
      <div class="sub-features">
        <img
          v-if="baseSku === 'velans'"
          src="~/assets/images/pdp/velans-sub-features-1.jpg"
          :class="$b('slide-image')"
        />
        <img
          v-if="baseSku === 'vulcans'"
          src="~/assets/images/pdp/vulcans-sub-features-1.jpg"
          :class="$b('slide-image')"
        />
        <img
          v-if="baseSku === 'airas'"
          src="~/assets/images/pdp/airas-sub-features-1.jpg"
          :class="$b('slide-image')"
        />

        <div class="text-cont">
          <BaseHeading size="h2">
            {{ $tr('Find your Fit.') }}
          </BaseHeading>
          <p
            v-html="
              $tr(
                '{productName} come with 4 different sized and easily interchanged nose pads for a fully adaptable fit that will suit any face, brow and nose shape.',
                { productName }
              )
            "
          />
        </div>
      </div>

      <div class="sub-features">
        <img
          v-if="baseSku === 'velans'"
          src="~/assets/images/pdp/velans-sub-features-2.jpg"
          :class="$b('slide-image')"
        />
        <img
          v-if="baseSku === 'vulcans'"
          src="~/assets/images/pdp/vulcans-sub-features-2.jpg"
          :class="$b('slide-image')"
        />
        <img
          v-if="baseSku === 'airas'"
          src="~/assets/images/pdp/airas-sub-features-2.jpg"
          :class="$b('slide-image')"
        />

        <div class="text-cont">
          <BaseHeading size="h2">
            {{ $tr('Lock it in.') }}
          </BaseHeading>
          <p
            v-html="
              $tr(
                'Earsocks and nose pads made from our Grip-Lock™ hydrophilic rubber for three evenly balanced points of grip. The more you sweat the more your {productName} hold in place.',
                { productName }
              )
            "
          />
        </div>
      </div>

      <div class="sub-features">
        <img
          src="~/assets/images/pdp/sub-features-3.jpg"
          :class="$b('slide-image')"
        />

        <div class="text-cont iris">
          <VisionIcon icon="iris" />
          <BaseHeading size="h2">
            {{ $tr('Built to Adapt.') }}
          </BaseHeading>
          <p
            v-html="
              $tr(
                'Our new 8KO® Iris™ photochromic lens adjusts to fast-changing light conditions, for no lapse in vision and ultimate focus.'
              )
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  name: 'PaceFeatures',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    baseSku: { type: String, required: true },
    productName: { type: String, required: true },
  },
  data() {
    return {
      activeSlide: 0,
    }
  },
  methods: {
    setActiveSlideByIndex(goToIndex) {
      this.activeSlide = goToIndex
      this.updateActiveSlide(goToIndex)
    },
    handleSlideChange(swiper) {
      this.activeSlide = swiper.activeIndex
    },
    updateActiveSlide(index) {
      this.$refs.featuresSwiper?.swiperInstance?.slideTo(index)
    },
  },
}
</script>

<style lang="postcss">
.sub-features-cont {
  .sub-features {
    width: 100%;
    float: left;
    position: relative;

    @screen md {
      width: calc(100% * 0.33333);
    }

    .text-cont {
      @apply text-off-black;
      max-width: 300px;
      width: 80%;
      left: 30px;
      position: absolute;
      bottom: 30px;
      height: 190px;

      p {
        font-size: 15px;
        font-weight: 200;
      }

      .BaseIcon {
        position: absolute;
        top: -20px;
      }

      &.iris {
        @apply text-white;
        text-shadow: 0px 0px 4px rgba(0, 0, 0, 1);
      }
    }

    img {
      width: 100%;
    }
  }
}

.PaceFeatures__pagination-cont {
  @apply text-center md:hidden;

  .PaceFeatures__pagination-bullet {
    --tw-bg-opacity: 1;
    background-color: rgb(213 216 218 / var(--tw-bg-opacity));
    font-size: 0;
    display: inline-block;
    height: 3px;
    width: 50px;
    margin: 14px 6px 4px 0px;
    padding: 0;
    outline: none;
  }

  .PaceFeatures__pagination-bullet--active {
    @apply bg-blue;
  }
}
</style>
